export function setCookie(cname, cvalue, exMins) {
	var d = new Date();
	d.setTime(d.getTime() + exMins * 60 * 1000);
	var expires = "expires=" + d.toGMTString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

export function removeCookie(cname) {
	const expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
	document.cookie = cname + "=;" + expires + ";path=/";
}
